import React, { useRef } from "react";
import { useParams, useHistory } from "react-router";
import { Table } from "react-bootstrap";
import "../../assets/styles/RetailPortalCouponsList.css";
import { CSVLink } from 'react-csv';

export default function CouponUserList(props) {
  const csvLink = useRef(null);
  const params = useParams();
  const history = useHistory();


  return (
    <div className="retail-store-list-container">
      <div className="table-header">
        <div>Coupon Users</div>
        <CSVLink
          data={props.users.map((item, index) => ({
            'Sr. No.': index + 1,
            'Primary Number': item?.mobile_no || '-',
            'Doosra number': item['Doosra number'] || '-',
          }))}
          filename={`users_availed_discount_${params}.csv`}
          ref={csvLink}

        />
        <div>
          {
            props?.users?.length > 0 &&
            <button
              style={{ marginRight: '16px' }}
              onClick={() => { csvLink.current.link.click() }}
            >Download List</button>
          }
          <button
            onClick={() => {
              const path = `/discount-coupon`;
              history.push(path);
            }}
          >
            Back
          </button>
        </div>
      </div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Primary Number</th>
            <th>Doosra Number</th>

          </tr>
        </thead>
        <tbody>
          {props?.users?.length > 0 && props.users.map((item, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.mobile_no || '-'}</td>
                <td>{item['Doosra number'] || '-'}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div >
  );
}

